<template>
    <el-popover
        v-if="popover"
        :popper-class="'ellipsis-popover' + (popover ? ' ellipsis-popover-' + popover : '') + ' ' + theme"
        :placement="popover"
        trigger="hover"
        :content="text">
        <div class="elli-txt-wrap" slot="reference">
            <template v-if="text.length > endLen">
                <div class="elli-txt" :style="elliStyle">{{ text.substr(0, text.length - endLen) }}</div>
                <div class="elli-suffix">{{ text.substr(text.length - endLen) }}</div>
            </template>
            <template v-else>{{ text }}</template>
        </div>
    </el-popover>
    <div v-else class="elli-txt-wrap">
        <template v-if="text.length > endLen">
            <div class="elli-txt" :style="elliStyle">{{ text.substr(0, text.length - endLen) }}</div>
            <div class="elli-suffix">{{ text.substr(text.length - endLen) }}</div>
        </template>
        <template v-else>{{ text }}</template>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            required: true
        },
        endLen: {
            type: Number,
            default: 3
        },
        popover: {
            type: String,
            default: ''
        },
        theme: {
            type: String,
            default: 'light'
        },
        elliStyle: {
            type: Object,
            default(){
                return {}
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.elli-txt-wrap{
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
    .elli-txt{
        overflow: hidden;
        max-width: fit-content;
        text-overflow: ellipsis;
        white-space: nowrap;
        text-align: center;
    }
    .elli-suffix{
        white-space: nowrap;
    }
}
</style>

<style>
.ellipsis-popover{
    min-width: auto;
    padding: 6px 13px;
    box-sizing: border-box;
    background: #FFFFFF;
    font-size: 14px;
    font-family: PingFang SC;
    color: #000000;
    text-align: center;
    border-radius: 5px;
}
.ellipsis-popover.dark{
    border-color: rgba(0, 0, 0, .9);
    background-color: rgba(0, 0, 0, .9);
    color: #fff;
}
.ellipsis-popover-top.dark .popper__arrow {
    border-top-color: rgba(0, 0, 0, .9);
}
.ellipsis-popover-top.dark .popper__arrow::after{
    border-top-color: rgba(0, 0, 0, .9);
}
.ellipsis-popover-bottom.dark .popper__arrow {
    border-bottom-color: rgba(0, 0, 0, .9);
}
.ellipsis-popover-bottom.dark .popper__arrow::after{
    border-bottom-color: rgba(0, 0, 0, .9);
}
.ellipsis-popover-top{
    margin-bottom: 6px !important;
}
.ellipsis-popover-bottom{
    margin-top: 6px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/Ellipsis/index.vue